import React from 'react';
import { Text, ThemeUIStyleObject } from 'theme-ui';

type Props = {
  note: string;
  confirmed?: boolean;
  forwardSx?: ThemeUIStyleObject;
};

const ShippingNote = ({ note, confirmed, forwardSx = {} }: Props) => {
  return (
    <Text
      as="p"
      sx={{
        fontWeight: 'medium',
        fontSize: '1.2rem',
        textAlign: 'center',
        backgroundColor: 'rgba(45, 145, 82, 0.2)',
        border: '1px solid rgba(45, 145, 82, 0.5)',
        boxSizing: 'border-box',
        p: '1rem 1.4rem',
        lineHeight: '100%',
        color: '#027320',
        borderBottomRightRadius: confirmed ? '1.6rem' : '0',
        ...forwardSx,
      }}
    >
      {note}
    </Text>
  );
};

export default ShippingNote;
